import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/icon/tou_xiang.png'


const _withScopeId = n => (_pushScopeId("data-v-df1f9320"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my_login" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img",
  fit: "cover",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "button_all" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("手机号码快捷登录")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("手机验证码登录")
const _hoisted_6 = { class: "uni_login_footer" }
const _hoisted_7 = { class: "div" }
const _hoisted_8 = { class: "xieyi" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 打勾表示您已阅读并同意以下协议 ")

import { ref } from "vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { showNotify, closeNotify } from "vant"

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const route = useRoute()
const checked = ref(false)
// 勾选协议判断
const phoneLogin = () => {
  showNotify({ type: "warning", message: "请阅读并同意用户协议和隐私协议" })
}
const codeLogin = () => {
  if (!checked.value) {
    showNotify({ type: "warning", message: "请阅读并同意用户协议和隐私协议" })
  } else {
    router.push({ path: "/codeLogin", query: { account_type: route.query.account_type } })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_checkbox = _resolveComponent("van-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (!checked.value)
        ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            color: "#ffcd01",
            type: "primary",
            class: "yellow_button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (phoneLogin()))
          }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (checked.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "yellow_button",
            plain: "",
            "open-type": "getPhoneNumber",
            onGetphonenumber: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getPhoneNumber && _ctx.getPhoneNumber(...args)))
          }, " 手机号码快捷登录 ", 32))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_van_button, {
      color: "#ffcd01",
      plain: "",
      type: "primary",
      class: "yellow_button code_login",
      onClick: codeLogin
    }, {
      default: _withCtx(() => [
        _hoisted_5
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_van_checkbox, {
          modelValue: checked.value,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((checked).value = $event)),
          class: "checkbox",
          "checked-color": "#ffcd01",
          "icon-size": "15px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("a", {
                plain: "",
                type: "link",
                class: "link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.yhxy()))
              }, "《用户协议》"),
              _createElementVNode("span", {
                class: "he",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.gotoCodeLogin && _ctx.gotoCodeLogin(...args)))
              }, "和"),
              _createElementVNode("a", {
                plain: "",
                type: "link",
                class: "link",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ysxy()))
              }, "《隐私协议》")
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ])
  ]))
}
}

})